import DOMPurify from 'dompurify';

class DOMService {
  purify(text: string | Node) {
    const dompurifyConfig = {
      ALLOWED_TAGS: [
        'br',
        'a',
        'img',
        'li',
        'ul',
        'b',
        'p',
        'strong',
        'i',
        'italic',
        'span',
        'em',
      ],
      ADD_ATTR: ['target', 'src'],
      ALLOWED_ATTR: ['href', 'target', 'class'],
    };

    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
      // set all elements owning target to target=_blank
      // TODO: Add hook for _parent if the page is in the same webpage, _blank otherwise
      if ('target' in node && node instanceof HTMLElement) {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener');
      }
    });

    const purifiedText = DOMPurify.sanitize(text, dompurifyConfig);
    return purifiedText;
  }
}

export default new DOMService();
